import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

export interface SubMenuItem {
  translateKey: string;
  postfix?: string;
  id: string;
  link?: string;
  active?: boolean;
}

@Component({
  selector: 'pac-sub-menu',
  templateUrl: './sub-menu.component.html',
  styleUrls: ['./sub-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubMenuComponent {
  @Input() list: SubMenuItem[];
  @Input() hasLink = true;
  @Output() selected: EventEmitter<string>;

  constructor() {
    this.selected = new EventEmitter<string>();
  }

  public select(item: SubMenuItem): void {
    this.selected.emit(item.id);
    this.list.forEach(_item => _item.active = item.translateKey === _item.translateKey);
  }
}
